module.exports = __webpack_public_path__ + "media/online_learning/analysis-46b9b237.svg";